
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import value2name from 'vux/src/filters/value2name.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import wx from 'weixin-js-sdk'
import global_ from "./global";

export default {
data() {
return {
isviwo: false,
devseq: "",
devname: "",
devmodel: '',
producer: '',
buyfrom: "",
company: '',
ftype: '',
name: '',
mobile: '',
fdesc: "",
title: '默认为空',
value_0_1: [],
value: [],
showLoading: false,
title2: '设置值',
value2: ['天津市', '市辖区', '和平区'],
value3: ['广东省', '中山市', '--'],
addressData: ChinaAddressV4Data,
value4: [],
value5: ['广东省', '深圳 市', '南山区'],
showAddress: false,
address: [],
address2: '',
viwoList: [{key: true, value: '是'}, {key: false, value: '否'}],
eduList: [{key: 1, value: '设备启动故障'}, {key: 2, value: '设备死机故障'}, {key: 3, value: '设备显示故障'}, {
key: 4,
value: '设备识别故障'
}, {key: 5, value: '设备输入输出故障'}, {key: 6, value: '设备音频故障'}, {key: 7, value: '设备其他故障'}],
imgUrl: '/static/img/flick.png',
imgList: {
version: '1.0',
content: []
},
isProducer:false,
producerList:[]
}
},
components: {
XHeader,
XInput,
Group,
XAddress,
Card,
XTextarea,
Alert,
Cell,
Selector,
XButton
},
methods: {
faultType() {
var obj = {
isviwo: this.isviwo,
sevenday: this.sevenday,
devseq: this.devseq,
devname: this.devname,
devmodel: this.devmodel,
producer: this.producer,
buyfrom: this.buyfrom,
company: this.company,
name: this.name,
mobile: this.mobile,
address: value2name(this.address, ChinaAddressV4Data),
address2: this.address2,
fdetail: this.imgList.content,
ftype: this.ftype,
fdesc: this.fdesc
}
localStorage.setItem('fault', JSON.stringify(obj))
this.$router.push({name: 'faultType', params: {repair: 'rapid'}})
},
findSrvp() {
this.$http.get('/api/v1/devices/companies?value=' + this.producer).then(response => {
this.producerList = response.data
if (this.producerList.length === 1){
if (this.producer !== this.producerList[0]){
this.isProducer = true;
}
}else{
this.isProducer = true;
}
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'warn',
position: 'top',
time: '10000'
})
})
},
chose(producer) {
this.producer = producer;
this.isProducer = false;
},
submit() {
this.showLoading = true;
var address = {
address1: value2name(this.address, ChinaAddressV4Data),
address2: this.address2
}
address.address1 = address.address1.split(' ')
if (this.ftype === '' || this.fdesc === ''){
this.showLoading = false
this.$vux.alert.show({
content: '请填写故障信息',
type: 'cancel'
})
return
}
if (this.name === '' || this.mobile === ''){
this.showLoading = false
this.$vux.alert.show({
content: '请填写报修人信息',
type: 'cancel'
})
return
}
if (this.address1 === ''){
this.showLoading = false
this.$vux.alert.show({
content: '请填写详细地址',
type: 'cancel'
})
return
}
if (this.ftype != '' && this.fdesc != '' && this.name != '' && this.mobile != '' && address.address1 != '' && address.devseq != '' && address.devname != '') {
var openid = localStorage.getItem("openid");
const unionid = localStorage.getItem('unionid');
const nickname = localStorage.getItem('nickname')
const imgurl = localStorage.getItem('imgurl')
var obj = {
openid: openid,
unionid:unionid,
otp:'official',
nickname:nickname,
imgurl:imgurl,
isviwo: this.isviwo,
devseq: this.devseq,
devname: this.devname,
devmodel: this.devmodel,
producer: this.producer,
buyfrom: this.buyfrom,
company: this.company,
name: this.name,
mobile: this.mobile,
ftype: this.ftype,
fdesc: this.fdesc,
province: address.address1[0],
city: address.address1[1],
district: address.address1[2],
address: address.address2,
fdetail: this.imgList
}
var that = this;
this.$http.post("api/v1/fastrepairs", obj)
.then((res) => {
if (res.status == 201) {
this.showLoading = false
that.$router.push({name: 'rapidrepairslist'})
}
})
.catch(function (error) {
this.showLoading = false
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
} else {
that.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
}
} else if (error.request) {
that.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
console.log(error.request)
} else {
that.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
console.log('Error', error.message)
}

})
} else {
this.showLoading = false
this.$vux.alert.show({
text: '输入信息不完整，请补全后再提交',
type: 'cancel',
})
}

},
sys_click: function () {
var that = this
wx.error(function (res) {
alert(res.errMsg)
})
wx.ready(function () {
wx.checkJsApi({
jsApiList: ['scanQRCode'],
success: function (res) {

}
});
wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function (res) {
var result = res.resultStr; 

var url = result.substring(result.lastIndexOf('?') + 1, result.length);
var loc = url.substring(url.lastIndexOf('=') + 1, url.length);
AjaxPlugin.$http.get('/api/v1/devices/' + loc + '/wechat?type=USER')
.then(function (response) {
if (response.data) {
that.devname = response.data.extname
that.devseq = response.data.sn
} else {
that.$vux.alert.show({
title: '',
content: '无法识别编码,请确定是否扫描编码?',
})
}
}).catch(err => {
that.$vux.confirm.show({
title: '',
content: '非云帷设备,请手动输入设备序列号和设备名称',
onConfirm() {
that.devname = ''
that.devseq = ''
that.$refs.content.focus()
}
})
})
}
});

});
},
back() {
this.$router.push({name: 'rapidrepairslist'})
}

},
mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
app.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {

url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.path
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then(function (response) {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode'] 
})
wx.error(function (res) {

})
})
.catch(function (error) {

if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
beforeRouteEnter(to, from, next) {
if (from.name == 'faultType') {
next(vm => {
if (vm.$route.params.obj) {
vm.devseq = vm.$route.params.obj.devseq
vm.devname = vm.$route.params.obj.devname
vm.devmodel = vm.$route.params.obj.devmodel
vm.producer = vm.$route.params.obj.producer
vm.buyfrom = vm.$route.params.obj.buyfrom
vm.company = vm.$route.params.obj.company
vm.ftype = vm.$route.params.obj.ftype
vm.name = vm.$route.params.obj.name
vm.mobile = vm.$route.params.obj.mobile
vm.fdesc = vm.$route.params.obj.fdesc
vm.address = vm.$route.params.obj.address.split(' ')
vm.address2 = vm.$route.params.obj.address2
vm.isviwo = vm.$route.params.obj.isviwo
vm.imgList.content = vm.$route.params.obj.fdetail
} else {
var fault = localStorage.getItem('fault')
var obj = JSON.parse(fault)
vm.devseq = obj.devseq
vm.devname = obj.devname
vm.devmodel = obj.devmodel
vm.producer = obj.producer
vm.buyfrom = obj.buyfrom
vm.company = obj.company
vm.ftype = obj.ftype
vm.name = obj.name
vm.mobile = obj.mobile
vm.fdesc = obj.fdesc
vm.address = obj.address.split(' ')
vm.address2 = obj.address2
vm.isviwo = obj.isviwo
vm.imgList.content = obj.fdetail
}
})
} else if (from.name == 'sbxx') {
next(vm => {
vm.devname = vm.$route.params.obj.extname
vm.devseq = vm.$route.params.obj.sn





})
} else {
next()
}

},
beforeRouteLeave(to, from, next) {
if (to.name == 'faultType') {
next()
} else {
localStorage.removeItem('obj')
localStorage.removeItem('ftype')
localStorage.removeItem('subClass1')
localStorage.removeItem('subClass2')
localStorage.removeItem('fdesc')
localStorage.removeItem('fault')

}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/rapidrepairs.vue